export default __webpack_public_path__ + "static/media/Portfolios-Viewer.0ecd4bdc.png";